import {
  GetExampleComponentDocument,
  GetExampleComponentQuery,
  GetExampleComponentQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';
import { getLocalesForGraphQL } from '../utils/helpers';

export async function getExampleComponent(id: string, locale: string) {
  return client.query<GetExampleComponentQuery, GetExampleComponentQueryVariables>({
    query: GetExampleComponentDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
